/**
 * Даты в админке.
 *
 * Бэкенд отдаёт ISO с таймзоной; оператор смотрит на них в своей локальной
 * зоне — это то, что нужно: «когда я это сделал» важнее, чем «сколько было в
 * Москве». Исключение — даты начислений (`date`, без времени): их не сдвигают
 * ни на час, иначе дата в таблице разъедется с датой в БД.
 */
const DATE_TIME = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const DATE = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function formatDateTime(iso: string): string {
  return DATE_TIME.format(new Date(iso));
}

/** `2026-08-22` → `22.08.2026`. Без `new Date`: он сдвинул бы дату на зону. */
export function formatDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-");
  return year && month && day ? `${day}.${month}.${year}` : DATE.format(new Date(isoDate));
}
